import { TFunction } from 'i18next'

export type TitleDuplicateValidationMode = 'create' | 'edit' | 'copy'

type ValidateDuplicateTitleParams = {
  value: string
  mode: TitleDuplicateValidationMode
  defaultValue: string
  hasDuplicate: boolean
  t: TFunction
  errorKey: 'error.duplicateViewTitle' | 'error.duplicateFormTitle' | 'error.duplicateSearchAssistantTitle'
}

export const validateDuplicateTitle = ({
  value,
  mode,
  defaultValue,
  hasDuplicate,
  t,
  errorKey,
}: ValidateDuplicateTitleParams): string | undefined => {
  const trimmed = value.trim()

  if ((mode === 'create' || mode === 'copy') && hasDuplicate) {
    return t(errorKey, { title: trimmed })
  }

  if (mode === 'edit' && hasDuplicate && trimmed !== defaultValue.trim()) {
    return t(errorKey, { title: trimmed })
  }
}
